import { withPlugins, domEvents } from '@spon/plugins';

function TabbedTable({ node, plugins: { addEvents } }) {
	let active = 0;
	const tabs = [...node.querySelectorAll('[aria-controls]')];
	const content = [...node.querySelectorAll('[aria-labelledby]')];

	function turnOn(id) {
		tabs[id].classList.add('is-active');
		tabs[id].setAttribute('aria-expanded', 'true');
		content[id].setAttribute('aria-hidden', 'false');
		content[id].classList.add('block');
		content[id].classList.remove('hidden');
	}

	function turnOff(id) {
		tabs[id].classList.remove('is-active');
		tabs[id].setAttribute('aria-expanded', 'false');
		content[id].setAttribute('aria-hidden', 'true');
		content[id].classList.add('hidden');
		content[id].classList.remove('block');
	}

	function onTab({ target }) {
		const { tab: tabTmp } = target.dataset;
		const tab = tabTmp - 1; // .... Craft....
		if (active === tab) return;
		turnOff(active);
		turnOn(tab);
		active = tab;
	}

	addEvents({
		'click [data-tab]': onTab,
	});

	/*
	 *		Return
	 */
	return () => {};
}
export default withPlugins(domEvents)(TabbedTable);


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
